























import Vue from 'vue'
import { mapMutations } from 'vuex'

export default Vue.extend({
  name: 'Modal',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialogStatus: false
    }
  },
  methods: {
    ...mapMutations(['updateModalStatus'])
  },
  model: {
    prop: 'dialog',
    event: 'changeState'
  },
  watch: {
    dialogStatus () {
      this.$emit('changeState', this.dialogStatus)
      this.updateModalStatus(this.dialogStatus)
    },
    dialog () {
      this.dialogStatus = this.dialog
    }
  }
})
